import React, { useState } from 'react';

import { toPercentTime, toPercentTimeDesc } from '../../../common/utils/convertUtil';


export default function ProgramBox(props) {

  const programs = props.data;

  const handleClick = (channelId) => {
    if (props.onChannelMove) {
      props.onChannelMove(channelId);
    }
  };

  return (

    <ul className="channel_list_w">
      {programs.map((item, index) => {
        let progressPercent =
          item.starttime && item.endtime
            ? toPercentTime(item.starttime, item.endtime)
            : null;
        progressPercent =
          progressPercent > 100 || progressPercent < 0
            ? null
            : progressPercent;
        const progressDesc = progressPercent
          ? toPercentTimeDesc(item.starttime, item.endtime, progressPercent)
          : '';

        return (
          <li className="channel_list_inner" key={index}>
            <div className="module_box_w_type1">
              <a
                className="mb_link"
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(item.channelid);

                }}
              >
                <div className="mb_image_w">
                  <div className="mb_image_inner">
                    <img
                      src={item.thumbimg}
                      className="mb_image"
                      alt={item.program.title}
                    />
                  </div>
                  <div className="mb_progress_w">
                    <i className="hide">라이브 총시간 및 진행시간</i>
                    <span
                      className="mb_progress"
                      style={{ width: `${progressPercent}%` }}
                      title={progressDesc}
                    ></span>
                  </div>
                  {(item.channelid === 'S17' ||
                    item.channelid === 'S18') && (
                      <div className="mb_label_w">
                        <span className="mb_label_bora" title="보는라디오">
                          보라
                        </span>
                      </div>
                    )}
                </div>
                <div className="mb_info_w">
                  <span className="mbif_title">{item.title}</span>
                  <span className="mbif_subinfo">{item.channelname}</span>
                </div>
              </a>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
